module.exports = __webpack_public_path__ + "static/20-e04b05c1bb5aa0dfacc71dcdea7e1cbe.png";